import { getJobTrackRoute } from 'lib/helpers';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Link from '/components/Link';
import { useResponsive } from '/imports/core/api/responsiveContext';
import useIntl from '/imports/core/api/useIntl';
import useDomain from '/imports/core/hooks/useDomain';
import Flex from '/imports/core/ui/atoms/Flex';
import ResumizemeLogo from '/imports/homepageV3/ui/atoms/svg/Logo';
import TheResumeRangerLogo from '/imports/homepageV4/ui/atoms/svg/Logo';
import LogoV6 from '/imports/homepageV6/ui/assets/LogoV6';
import HomepageV7Logo from '/imports/homepageV7/ui/assets/HomepageV7Logo';
import CurvedLogo from '/imports/landing/ui/assets/Logo';
import LogoV2 from '/imports/newHomePage/ui/atmos/Logo';
import { websiteFontLoad } from '/lib/helpers';
import HomepageV8Logo from 'imports/homepageV8/ui/assets/HomepageV8Logo';

function Logo({ light, huge, noLink, path, height, width, curvedLogo, title, withHeader, noRedirection }) {
  const { host: domain, breakpoint } = useResponsive();
  const isMobile = breakpoint === 'xs';
  const { locale } = useIntl();
  const { getBrandName } = useDomain();
  let Component, mainTitle, viewBox;
  switch (domain) {
    case 'cvmachine':
      Component = NewLandingPageLogo;
      mainTitle = 'Cvmachine';
      break;
    case 'cvelevator':
      Component = NewLandingPageLogo;
      mainTitle = 'Cvelevator';
      break;
    case 'quantumresume':
      Component = NewLandingPageLogo;
      mainTitle = 'Quantumresume';
      break;
    case 'bluepill':
    case 'bluepillwork':
      Component = LogoBluePill;
      mainTitle = getBrandName();
      break;
    case 'applycator':
    case 'autoapply':
      Component = LogoAutoApply;
      mainTitle = getBrandName();
      break;
    case 'kazakhstan-cv':
      Component = BlogLogo;
      mainTitle = getBrandName();
      width = 210;
      height = 30;
      break;
    case 'verycoolcv':
      Component = BlogLogo;
      mainTitle = 'VeryCoolCv';
      width = 250;
      height = 30;
      break;
    case 'zivotopis-primjer':
      Component = BlogLogo;
      mainTitle = getBrandName();
      width = 220;
      height = 30;
      break;
    case 'resumizeme':
      Component = Resumizeme;
      break;
    case 'cvtoolspro':
      Component = ResumeNationLogo;
      break;
    case 'cvkoostamine':
      Component = BlogLogo;
      mainTitle = getBrandName();
      width = 270;
      height = 27;
      break;
    case 'theresumeranger':
      Component = TheResumeRanger;
      break;
    case 'cvdeboss':
      Component = LogoCommon;
      mainTitle = 'CVDeBoss';
      break;
    case 'bestonlineresume':
      Component = LogoCommon;
      mainTitle = 'BestOnlineResume';
      width = 220;
      viewBox = '0 0 100 10';
      break;
    case 'mysmartcv':
      Component = LogoMySmartCV;
      width = 126;
      mainTitle = 'MySmartCV';
      break;
    case 'buildmycv':
      Component = LogoBuildMyCV;
      mainTitle = 'BuildMyCV';
      break;
    case 'curriculumlisto':
      Component = LogoCurriculumListo;
      mainTitle = 'CurriculumListo';
      break;
    case 'resume-example':
      Component = BlogLogo;
      width = isMobile ? 27 : 250;
      height = 27;
      mainTitle = 'Resume-Example';
      break;
    case 'modeles-cv':
      Component = BlogLogo;
      width = isMobile ? 27 : 200;
      height = 27;
      mainTitle = 'Modeles-CV';
      break;
    case 'ejemplos-curriculum':
      Component = BlogLogo;
      width = 250;
      height = 27;
      mainTitle = 'Ejemplos-Curriculum';
      break;
    case 'cv-in-arabic':
      Component = BlogLogo;
      width = 175;
      height = 27;
      mainTitle = 'CV In Arabic';
      break;
    case 'modelos-de-curriculo':
      Component = BlogLogo;
      width = 260;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'cv-hebrew':
      Component = BlogLogo;
      width = 165;
      height = 27;
      mainTitle = 'CV-Hebrew';
      break;
    case 'resume-nation':
      Component = ResumeNationLogo;
      break;
    case 'lebenslaufschreiben':
      Component = BlogLogo;
      width = 260;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'resumedone':
      Component = curvedLogo ? CurvedLogo : LogoSVG;
      mainTitle = 'Resumedone';
      //withHeader = withHeader;
      break;
    case 'xn--e1aaaggwcwefd4n':
      Component = BlogLogo;
      width = 230;
      height = 27;
      mainTitle = 'резюмепример';
      break;
    case 'criarcv':
      Component = BlogLogo;
      width = 140;
      height = 27;
      mainTitle = 'criarcv';
      break;
    case 'cv-pavyzdys':
      Component = BlogLogo;
      width = 190;
      height = 27;
      mainTitle = 'cv-pavyzdys';
      break;
    case 'contoh-resume':
      Component = BlogLogo;
      width = 210;
      height = 27;
      mainTitle = 'contoh-resume';
      break;
    case 'thai-resume':
      Component = BlogLogo;
      width = 190;
      height = 27;
      mainTitle = 'thai-resume';
      break;
    case 'xn--mxabdxcg5aeo5c':
      Component = BlogLogo;
      width = 160;
      height = 27;
      mainTitle = 'βιογραφικο';
      break;
    case 'cv-pohja':
      Component = BlogLogo;
      width = 160;
      height = 27;
      mainTitle = 'cv-pohja';
      break;
    case 'cveksempel':
      Component = BlogLogo;
      width = 190;
      height = 27;
      mainTitle = 'cveksempel';
      break;
    case 'cvminta':
      Component = BlogLogo;
      width = 150;
      height = 27;
      mainTitle = 'cvminta';
      break;
    case 'cvvzor':
      Component = BlogLogo;
      width = 130;
      height = 27;
      mainTitle = 'cvvzor';
      break;
    case 'cv-voorbeeld':
      Component = BlogLogo;
      width = 210;
      height = 27;
      mainTitle = 'cv-voorbeeld';
      break;
    case 'cv-wzor':
      Component = BlogLogo;
      width = 140;
      height = 27;
      mainTitle = 'cv-wzor';
      break;
    case 'cvhazirlama':
      Component = BlogLogo;
      width = 190;
      height = 27;
      mainTitle = 'CV Hazirlama';
      break;
    case 'cv-skabelon':
      Component = BlogLogo;
      width = 180;
      height = 27;
      mainTitle = 'CV Skabelon';
      break;
    case 'resumetiger':
      Component = BlogLogo;
      width = 240;
      height = 28;
      mainTitle = 'Resume Tiger';
      break;
    case 'quantumresume':
      Component = BlogLogo;
      width = 240;
      height = 27;
      mainTitle = 'Quantum Resume';
      break;
    case 'atelierdecv':
      Component = BlogLogo;
      width = 180;
      height = 27;
      mainTitle = 'Atelier de CV';
      break;
    case 'dreamresume':
      Component = BlogLogo;
      width = 205;
      height = 27;
      mainTitle = 'Dream Resume';
      break;
    case 'cv-lite':
      Component = ResumeNationLogo;
      width = 170;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'cvenminutos':
      Component = BlogLogo;
      width = 195;
      height = 27;
      mainTitle = 'CV en Minutos';
      break;
    case 'elegantcv':
      Component = BlogLogo;
      width = isMobile ? 27 : 170;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'neuroresumeai':
      Component = BlogLogo;
      width = isMobile ? 27 : 300;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'cvforwinners':
      Component = BlogLogo;
      width = isMobile ? 27 : 300;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'cvforsuccess':
      Component = BlogLogo;
      width = isMobile ? 27 : 200;
      height = 27;
      mainTitle = getBrandName();
      break;
    case 'cvitaliano':
      Component = BlogLogo;
      width = isMobile ? 27 : 200;
      height = 27;
      mainTitle = getBrandName();
      break;
    default:
      Component = BlogLogo;
      width = 170;
      height = 27;
      mainTitle = getBrandName();
  }

  const logoProps = {
    light,
    huge,
    height,
    width,
    text: mainTitle,
    withHeader,
  };

  if (viewBox) {
    logoProps.viewBox = viewBox;
  }

  if (noLink) {
    return <Component {...logoProps} />;
  }

  // Next <Link> requires a href/as props if the page name
  // and URL path are different.
  const { href, as } = getJobTrackRoute(domain, 'resumes');
  const asProp = path === '/dashboard' ? as : undefined;
  const hrefv2 = path === '/dashboard' ? href : path;

  return !noRedirection ? (
    <Link href={hrefv2} as={asProp} passHref>
      <LinkUnstyled title={title || mainTitle} $locale={locale} $isMobile={isMobile}>
        <Component {...logoProps} />
      </LinkUnstyled>
    </Link>
  ) : (
    <Component {...logoProps} />
  );
}

Logo.propTypes = {
  light: PropTypes.bool,
  huge: PropTypes.bool,
  noLink: PropTypes.bool,
  path: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  curvedLogo: PropTypes.any,
  title: PropTypes.string,
  withHeader: PropTypes.any,
};

const NewLandingPageLogo = (props) => {
  const { host } = useResponsive();
  const { getBrandName } = useDomain();

  const getLogo = () => {
    switch (host) {
      case 'quantumresume':
        return <LogoV6 />;
      case 'cvelevator':
        return <HomepageV7Logo />;
      case 'cvmachine':
        return <HomepageV8Logo />;
    }
  };

  return (
    <StyledFlex $alignItems="center" $nomargin={true}>
      <NoShrinkWrapper>{getLogo()}</NoShrinkWrapper>
      <NoShrinkWrapper>
        <TextV2 $light={props?.light}>{props?.text || getBrandName()}</TextV2>
      </NoShrinkWrapper>
    </StyledFlex>
  );
};

const LogoBluePill = (props) => {
  return (
    <svg width="144" height="44" viewBox="0 0 512 236" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_22940_2)">
        <path
          d="M235.681 202.537V234.61C235.681 236.182 234.032 234.962 233.919 234.962H211.01V127.818H260.705C263.447 127.818 272.413 130.969 275.191 132.365C305.699 147.739 296.429 202.537 260.705 202.537H235.681ZM235.681 182.095H252.951C254.312 182.095 258.753 180.248 260.134 179.41C270.327 173.221 270.172 154.076 258.943 149.318C258.041 148.937 253.551 147.555 252.951 147.555H235.681V182.095Z"
          fill="#0F89F8"
        />
        <path
          d="M251.542 15.0354C264.49 16.0857 278.18 22.8033 279.413 37.2114C280.308 47.6579 277.087 54.6505 268.818 60.8394C290.72 69.7423 287.047 102.139 265.139 108.977C263.363 109.534 257.991 110.894 256.483 110.894H211.017V15.0354C224.178 15.8249 238.529 13.9781 251.549 15.0354H251.542ZM231.452 53.0997H249.427C249.998 53.0997 254.347 50.8934 255.073 50.2872C259.112 46.9248 259.168 39.9182 256.13 35.8227C251.161 29.1403 239.995 33.3063 232.89 31.537C232.368 31.1775 231.452 32.0797 231.452 32.3053V53.0997ZM231.452 93.2787H248.722C249.194 93.2787 253.635 92.1861 254.403 91.9112C263.088 88.7321 263.236 75.2475 255.003 71.4974C254.319 71.1873 250.555 70.0242 250.132 70.0242H231.452V93.2857V93.2787Z"
          fill="#0F8BF9"
        />
        <path
          d="M385.119 15.0352V80.2379C385.119 80.6044 386.599 84.7704 386.952 85.4541C391.463 94.4345 408.373 94.3217 412.546 85.1017C412.857 84.4179 414.02 80.6538 414.02 80.2308V15.0352H435.871V86.5819C435.871 86.9908 434.222 92.1224 433.884 93.0529C422.838 123.3 362.562 117.9 362.562 83.0575V15.0352H385.119Z"
          fill="#0F8AF9"
        />
        <path
          d="M512 34.0673H474.641V53.0995H504.599C505.099 53.0995 507.066 53.6211 507.066 54.1568V72.1316H474.641V91.1637H511.295V110.901H452.789V15.0352H510.943C511.02 15.0352 512 16.015 512 16.0925V34.0673Z"
          fill="#0F8AF9"
        />
        <path d="M318.859 15.0352V90.4589H354.809V110.901H296.302V15.0352H318.859Z" fill="#0F8AF9" />
        <path
          d="M459.133 127.818V213.111H503.541V235.667H436.224C435.991 235.667 435.152 234.737 434.462 234.962V127.818H459.133Z"
          fill="#108AF9"
        />
        <path
          d="M379.48 127.818V212.053C379.48 212.638 381.186 213.301 381.912 213.146L420.364 213.111V234.61C420.364 235.195 418.658 235.858 417.932 235.702C398.787 234.976 379.127 236.464 360.06 235.702C358.255 235.632 355.344 235.667 354.104 234.61V127.818H379.48Z"
          fill="#108AF9"
        />
        <path
          d="M332.957 127.818V234.61C332.957 234.941 331.907 235.688 331.336 235.547C327.106 235.294 322.82 235.012 318.556 234.962C317.435 234.948 316.272 235.569 315.024 235.569C313.699 235.569 307.581 235.308 307.581 234.61V127.818H332.957Z"
          fill="#108AF9"
        />
        <path
          d="M159.306 83.1633C133.817 110.217 105.269 134.769 79.2019 161.308C38.6564 192.944 -16.2901 154.513 4.57477 105.008C11.9127 87.5971 35.7523 70.0875 49.5964 56.9835C64.2018 43.1605 80.069 25.6369 95.3934 13.2589C145.067 -26.8355 207.493 32.0021 159.299 83.1562L159.306 83.1633Z"
          fill="url(#paint0_linear_22940_2)"
        />
        <path
          d="M101.047 82.0001C108.723 88.8869 119.853 104.93 120.657 115.419C120.692 115.877 120.417 116.258 120.079 116.54C120.093 120.064 119.184 123.074 115.152 122.884C108.152 94.089 82.7828 68.4238 54.6928 59.6056C53.7552 59.3096 52.6697 59.4505 51.704 59.4364C51.1965 56.356 52.4653 57.7235 54.5447 57.0046C61.4668 54.622 63.0599 55.7005 69.8127 58.6047C81.077 63.4473 92.9333 72.9352 101.054 81.9931L101.047 82.0001Z"
          fill="#025EF9"
        />
        <path
          d="M120.079 116.54C120.036 106.46 107.729 89.451 101.047 82.0003C102.929 80.7315 105.917 85.6023 106.975 86.998C112.121 93.7227 119.592 105.6 121.059 113.869C121.298 115.236 121.728 115.863 120.072 116.54H120.079Z"
          fill="#0A7EFD"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_22940_2"
          x1="56.1026"
          y1="51.1963"
          x2="119.282"
          y2="119.501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1194FD" />
          <stop offset="0.16" stopColor="#18ABFE" />
          <stop offset="0.67" stopColor="#0362F9" />
          <stop offset="1" stopColor="#147CF4" />
        </linearGradient>
        <clipPath id="clip0_22940_2">
          <rect width="512" height="235.921" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LogoAutoApply = ({ light }) => {
  return (
    <svg width="144" height="24" viewBox="0 0 144 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.0244 11.3063L14.8777 0.695639C14.3404 -0.231881 12.9971 -0.231879 12.4598 0.695641L0.219352 21.8257C-0.317952 22.7532 0.35368 23.9126 1.42829 23.9126H2.53455C10.6628 23.2065 17.5723 18.2606 21.0244 11.3063Z"
        fill={light ? '#fff' : '#5050FA'}
      />
      <path
        d="M25.9092 23.9126H24.5859C23.3202 23.8021 22.0601 23.586 20.8191 23.2639C19.2365 22.853 17.7113 22.2763 16.2672 21.5486C18.8585 19.5524 21.0578 17.0751 22.7301 14.2509L27.1182 21.8257C27.6555 22.7532 26.9838 23.9126 25.9092 23.9126Z"
        fill={light ? '#fff' : '#5050FA'}
      />
      <path
        d="M5.27379 13.1357L0.189105 21.9131C-0.348199 22.8406 0.323434 24 1.39804 24H2.5043C6.34132 23.6667 9.90675 22.3886 12.9651 20.4004C9.92515 18.5331 7.30379 16.0542 5.27379 13.1357Z"
        fill={light ? '#fff' : '#A2E6C3'}
      />
      <path
        d="M36.2433 18.7825L41.5056 4.22506H44.827L50.2494 18.7825H48.2285L43.3264 5.50133L44.2868 5.97993H41.9257L42.9462 5.50133L38.2041 18.7825H36.2433ZM39.3846 14.4352L40.0449 12.6803H46.3477L47.008 14.4352H39.3846Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M56.232 19.1016C54.9648 19.1016 53.991 18.6894 53.3107 17.8652C52.6304 17.0409 52.2903 15.8511 52.2903 14.2956V8.11369H54.2111V14.6745C54.2111 15.5121 54.4379 16.1701 54.8914 16.6487C55.3449 17.114 55.9585 17.3467 56.7322 17.3467C57.5326 17.3467 58.1862 17.0941 58.6931 16.5889C59.2 16.0704 59.4534 15.3658 59.4534 14.4751V8.11369H61.3742V18.7825H59.8536V14.2158H60.0937C60.0937 15.2661 59.9536 16.1568 59.6735 16.888C59.3934 17.6059 58.9732 18.1576 58.4129 18.5432C57.866 18.9154 57.1657 19.1016 56.312 19.1016H56.232Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M69.2563 18.9021C68.4559 18.9021 67.7623 18.7891 67.1754 18.5631C66.6018 18.3371 66.1549 17.9516 65.8348 17.4065C65.528 16.8481 65.3746 16.097 65.3746 15.1531V4.90308H67.2154V15.3924C67.2154 15.9641 67.3688 16.4094 67.6756 16.7285C67.9957 17.0343 68.4426 17.1872 69.0162 17.1872H70.897V18.9021H69.2563ZM63.5338 9.56943V8.13363H70.897V9.56943H63.5338Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M78.4578 19.1414C77.524 19.1414 76.7037 18.9819 75.9967 18.6628C75.2897 18.3438 74.6895 17.925 74.1959 17.4065C73.7157 16.8747 73.3489 16.2831 73.0955 15.6317C72.8553 14.9803 72.7353 14.3156 72.7353 13.6375V13.2786C72.7353 12.6006 72.862 11.9358 73.1155 11.2844C73.3689 10.6197 73.7424 10.0281 74.2359 9.50961C74.7295 8.97783 75.3298 8.55906 76.0367 8.25328C76.7437 7.93422 77.5507 7.77468 78.4578 7.77468C79.3649 7.77468 80.1719 7.93422 80.8788 8.25328C81.5858 8.55906 82.1861 8.97783 82.6796 9.50961C83.1732 10.0281 83.5467 10.6197 83.8001 11.2844C84.0536 11.9358 84.1803 12.6006 84.1803 13.2786V13.6375C84.1803 14.3156 84.0536 14.9803 83.8001 15.6317C83.56 16.2831 83.1932 16.8747 82.6996 17.4065C82.2194 17.925 81.6258 18.3438 80.9189 18.6628C80.2119 18.9819 79.3915 19.1414 78.4578 19.1414ZM78.4578 17.4265C79.2581 17.4265 79.9384 17.2536 80.4987 16.908C81.0723 16.549 81.5058 16.0704 81.7992 15.4722C82.106 14.8739 82.2595 14.2025 82.2595 13.4581C82.2595 12.7003 82.106 12.0223 81.7992 11.424C81.4924 10.8258 81.0523 10.3538 80.4787 10.0081C79.9184 9.66249 79.2448 9.48967 78.4578 9.48967C77.6841 9.48967 77.0105 9.66249 76.4369 10.0081C75.8633 10.3538 75.4231 10.8258 75.1163 11.424C74.8095 12.0223 74.6561 12.7003 74.6561 13.4581C74.6561 14.2025 74.8029 14.8739 75.0963 15.4722C75.4031 16.0704 75.8366 16.549 76.3969 16.908C76.9705 17.2536 77.6574 17.4265 78.4578 17.4265Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M85.7766 18.7825L91.0389 4.22506H94.3604L99.7827 18.7825H97.7618L92.8597 5.50133L93.8201 5.97993H91.4591L92.4795 5.50133L87.7375 18.7825H85.7766ZM88.918 14.4352L89.5783 12.6803H95.881L96.5413 14.4352H88.918Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M102.181 22.7708V8.13363H103.702V12.7402L103.341 12.7003C103.408 11.557 103.648 10.6263 104.062 9.90844C104.489 9.17725 105.042 8.63882 105.723 8.29317C106.403 7.94751 107.143 7.77468 107.943 7.77468C108.717 7.77468 109.417 7.92092 110.044 8.2134C110.685 8.50588 111.232 8.90471 111.685 9.4099C112.139 9.91509 112.485 10.5 112.726 11.1648C112.966 11.8295 113.086 12.5341 113.086 13.2786V13.6375C113.086 14.382 112.959 15.0866 112.706 15.7514C112.452 16.4161 112.092 17.001 111.625 17.5062C111.172 18.0114 110.625 18.4102 109.984 18.7027C109.357 18.9952 108.664 19.1414 107.903 19.1414C107.143 19.1414 106.416 18.9753 105.723 18.6429C105.029 18.3105 104.455 17.7721 104.002 17.0276C103.548 16.2831 103.288 15.306 103.221 14.0962L104.102 15.6915V22.7708H102.181ZM107.603 17.4663C108.324 17.4663 108.951 17.3002 109.484 16.9678C110.018 16.6221 110.431 16.1502 110.725 15.5519C111.018 14.9404 111.165 14.2424 111.165 13.4581C111.165 12.6604 111.018 11.9624 110.725 11.3642C110.431 10.7659 110.018 10.3006 109.484 9.96827C108.951 9.62261 108.324 9.44978 107.603 9.44978C106.963 9.44978 106.369 9.59602 105.823 9.8885C105.276 10.1677 104.835 10.5798 104.502 11.1249C104.182 11.6567 104.022 12.3014 104.022 13.0592V13.9765C104.022 14.7077 104.189 15.3326 104.522 15.8511C104.855 16.3695 105.296 16.7684 105.843 17.0476C106.389 17.3267 106.976 17.4663 107.603 17.4663Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M115.976 22.7708V8.13363H117.497V12.7402L117.137 12.7003C117.203 11.557 117.443 10.6263 117.857 9.90844C118.284 9.17725 118.837 8.63882 119.518 8.29317C120.198 7.94751 120.938 7.77468 121.739 7.77468C122.512 7.77468 123.213 7.92092 123.839 8.2134C124.48 8.50588 125.027 8.90471 125.48 9.4099C125.934 9.91509 126.281 10.5 126.521 11.1648C126.761 11.8295 126.881 12.5341 126.881 13.2786V13.6375C126.881 14.382 126.754 15.0866 126.501 15.7514C126.247 16.4161 125.887 17.001 125.42 17.5062C124.967 18.0114 124.42 18.4102 123.779 18.7027C123.153 18.9952 122.459 19.1414 121.699 19.1414C120.938 19.1414 120.211 18.9753 119.518 18.6429C118.824 18.3105 118.25 17.7721 117.797 17.0276C117.343 16.2831 117.083 15.306 117.017 14.0962L117.897 15.6915V22.7708H115.976ZM121.398 17.4663C122.119 17.4663 122.746 17.3002 123.279 16.9678C123.813 16.6221 124.226 16.1502 124.52 15.5519C124.813 14.9404 124.96 14.2424 124.96 13.4581C124.96 12.6604 124.813 11.9624 124.52 11.3642C124.226 10.7659 123.813 10.3006 123.279 9.96827C122.746 9.62261 122.119 9.44978 121.398 9.44978C120.758 9.44978 120.165 9.59602 119.618 9.8885C119.071 10.1677 118.631 10.5798 118.297 11.1249C117.977 11.6567 117.817 12.3014 117.817 13.0592V13.9765C117.817 14.7077 117.984 15.3326 118.317 15.8511C118.651 16.3695 119.091 16.7684 119.638 17.0476C120.185 17.3267 120.771 17.4663 121.398 17.4663Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M129.891 18.7825V4.22506H131.812V18.7825H129.891ZM128.411 5.74063V4.22506H131.812V5.74063H128.411Z"
        fill={light ? '#fff' : '#3596d5'}
      />
      <path
        d="M134.776 22.9304V21.2154H136.317C136.77 21.2154 137.15 21.1555 137.457 21.0359C137.777 20.9295 138.037 20.7434 138.237 20.4775C138.451 20.2116 138.624 19.8593 138.758 19.4206L142.119 8.13363H144L140.438 19.9192C140.225 20.6238 139.925 21.1954 139.538 21.6341C139.151 22.0862 138.678 22.4119 138.117 22.6113C137.571 22.824 136.93 22.9304 136.197 22.9304H134.776ZM138.037 18.5432V16.9479H140.358V18.5432H138.037ZM137.837 18.5432L134.016 8.13363H135.977L139.638 18.5432H137.837Z"
        fill={light ? '#fff' : '#3596d5'}
      />
    </svg>
  );
};
Logo.defaultProps = {
  width: 169,
  height: 22,
  path: '/',
};

const LogoSVG = ({ light, huge, height, width, withHeader }) => (
  <StyledFlex1 withHeader={withHeader}>
    <SVG
      width={width}
      height={height}
      viewBox="0 0 169 22"
      xmlns="http://www.w3.org/2000/svg"
      light={light}
      huge={huge}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4453 21L5.22266 12.291H4.66211V21H0V1.06641H7.4375C12.0859 1.06641 13.9727 3.77344 13.9727 7.12305C13.9727 9.87109 12.3867 11.5527 9.84375 12.0996L15.9688 21H10.4453ZM4.66211 4.89453V9.26953H6.68555C8.75 9.26953 9.54297 8.42188 9.54297 7.0957C9.54297 5.76953 8.75 4.89453 6.68555 4.89453H4.66211ZM30.2182 13.6855L30.1636 14.7383H19.7866C19.978 16.8027 21.3999 17.7871 23.1362 17.7871C24.4487 17.7871 25.4468 17.2266 25.9253 16.0781L30.0268 16.6387C29.1108 19.6055 26.4722 21.2734 23.1636 21.2734C18.3921 21.2734 15.3706 18.5664 15.3706 13.877C15.3706 9.17383 18.4878 6.42578 23.0132 6.42578C27.1147 6.42578 30.1909 8.62695 30.2182 13.6855ZM23.0405 9.54297C21.3999 9.54297 20.2925 10.2266 19.9097 11.8672H25.8296C25.5835 10.3359 24.4761 9.54297 23.0405 9.54297ZM37.3857 21.2734C34.1318 21.2734 31.5888 20.0566 31.0556 17.3086L34.7607 16.2695C35.2256 17.7324 36.2099 18.2109 37.4131 18.2109C38.2607 18.2109 39.1904 17.9785 39.1767 17.0352C39.1767 15.6133 36.7978 15.5586 34.5556 14.6973C32.9287 14.0957 31.3974 13.1523 31.3974 10.8008C31.3974 7.83398 33.872 6.4668 37.1533 6.4668C39.9834 6.4668 42.3623 7.47852 42.9365 10.2539L39.5185 11.0059C39.0537 9.78906 38.247 9.37891 37.167 9.37891C36.1963 9.37891 35.4443 9.69336 35.4443 10.3906C35.4443 11.3887 37.0849 11.5664 38.8623 12.0586C41.0498 12.6602 43.4697 13.6719 43.4697 16.748C43.4697 20.0977 40.5849 21.2734 37.3857 21.2734ZM54.8618 6.72656H59.3188V21H55.1079L54.9985 19.3184C53.9731 20.5488 52.3598 21.2734 50.3774 21.2734C46.7954 21.2734 44.936 19.4688 44.936 16.3379V6.72656H49.4204V15.3809C49.4204 17.1172 50.5278 17.7188 51.7993 17.7188C53.3579 17.7188 54.8344 16.9941 54.8618 14.3828V6.72656ZM80.0078 6.45312C83.1796 6.45312 85.1757 7.99805 85.1757 10.9102V21H80.705V12.1953C80.705 10.6641 79.7343 10.0078 78.6269 10.0078C77.287 10.0078 76.0429 10.7324 76.0429 13.1934V21H71.5312V12.2227C71.5312 10.6777 70.5742 10.0078 69.412 10.0078C68.1132 10.0078 66.8281 10.7324 66.8281 13.4395V21H62.3847V6.72656H66.8281V8.36719C67.8124 7.13672 69.2753 6.45312 71.0253 6.45312C73.1718 6.45312 74.7578 7.19141 75.5234 8.53125C76.5624 7.13672 78.1074 6.45312 80.0078 6.45312ZM101.708 13.6855L101.654 14.7383H91.2768C91.4682 16.8027 92.8901 17.7871 94.6264 17.7871C95.9389 17.7871 96.9369 17.2266 97.4155 16.0781L101.517 16.6387C100.601 19.6055 97.9623 21.2734 94.6537 21.2734C89.8822 21.2734 86.8608 18.5664 86.8608 13.877C86.8608 9.17383 89.978 6.42578 94.5033 6.42578C98.6049 6.42578 101.681 8.62695 101.708 13.6855ZM94.5307 9.54297C92.8901 9.54297 91.7826 10.2266 91.3998 11.8672H97.3197C97.0737 10.3359 95.9662 9.54297 94.5307 9.54297ZM113.688 0H118.145V21H113.934L113.825 19.4004C113.046 20.6582 111.378 21.3418 109.518 21.3418C105.731 21.3418 102.6 18.6074 102.6 13.9043C102.6 9.20117 105.745 6.45312 109.518 6.45312C111.268 6.45312 112.854 7.05469 113.688 8.18945V0ZM110.558 17.6641C112.526 17.6641 114.058 16.2422 114.058 13.9043C114.058 11.5664 112.526 10.1309 110.558 10.1309C108.589 10.1309 107.058 11.5254 107.058 13.9043C107.058 16.2695 108.589 17.6641 110.558 17.6641ZM128.061 21.2734C123.371 21.2734 120.049 18.5391 120.049 13.8496C120.049 9.1875 123.344 6.45312 128.061 6.45312C132.791 6.45312 136.086 9.1875 136.086 13.8496C136.086 18.5391 132.778 21.2734 128.061 21.2734ZM128.006 17.7734C130.207 17.7734 131.657 16.1875 131.657 13.8496C131.657 11.5254 130.207 9.93945 128.006 9.93945C125.901 9.93945 124.479 11.5254 124.479 13.8496C124.479 16.1875 125.901 17.7734 128.006 17.7734ZM146.945 6.45312C150.514 6.45312 152.373 8.25781 152.373 11.4023V21H147.889V12.3457C147.889 10.6094 146.795 10.0078 145.51 10.0078C143.965 10.0078 142.474 10.7324 142.447 13.3438V21H137.99V6.72656H142.447V8.25781C143.473 7.12305 145.045 6.45312 146.945 6.45312ZM168.878 13.6855L168.824 14.7383H158.447C158.638 16.8027 160.06 17.7871 161.796 17.7871C163.109 17.7871 164.107 17.2266 164.585 16.0781L168.687 16.6387C167.771 19.6055 165.132 21.2734 161.824 21.2734C157.052 21.2734 154.031 18.5664 154.031 13.877C154.031 9.17383 157.148 6.42578 161.673 6.42578C165.775 6.42578 168.851 8.62695 168.878 13.6855ZM161.701 9.54297C160.06 9.54297 158.952 10.2266 158.57 11.8672H164.49C164.244 10.3359 163.136 9.54297 161.701 9.54297Z"
      />
    </SVG>
  </StyledFlex1>
);

LogoSVG.propTypes = {
  light: PropTypes.bool,
  huge: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  withHeader: PropTypes.any,
};

const LogoCommon = ({ light, height, width, viewBox = '0 0 56 10', text = '' }) => {
  const { locale } = useIntl();
  return (
    <StyledFlex1>
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g
          stroke="none"
          strokeWidth={1}
          fontFamily={websiteFontLoad(locale).websiteExtraBold}
          fontSize={11.5}
          fontWeight={600}
        >
          <text id="CVdeBoss" fill={light ? '#fff' : '#000000'}>
            <tspan x="0.352" y={9}>
              {text}
            </tspan>
          </text>
        </g>
      </svg>
    </StyledFlex1>
  );
};
LogoCommon.propTypes = {
  light: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.number,
  text: PropTypes.string,
};

const LogoBuildMyCV = ({ light, height, width, viewBox = '0 0 56 10' }) => (
  <StyledFlex1>
    <BuildMyCV width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.30823 3.94405C4.93195 3.6324 5.34775 3.03058 5.34775 2.2998C5.34775 1.21438 4.40064 0.322402 3.22251 0.322402H0V7.84512H3.48817C4.71249 7.84512 5.69426 6.93164 5.69426 5.79249C5.69426 4.93275 5.11675 4.23421 4.30823 3.94405ZM3.22251 0.859739C4.05413 0.859739 4.73559 1.50454 4.73559 2.2998C4.73559 3.09506 4.05413 3.73986 3.22251 3.73986H0.612162V0.859739H3.22251ZM3.48817 7.30778H0.612162V4.2772H3.48817C4.36598 4.2772 5.0821 4.95424 5.0821 5.79249C5.0821 6.63074 4.36598 7.30778 3.48817 7.30778Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M11.3517 2.47175V5.30889C11.3517 6.7597 10.4623 7.44749 9.33042 7.44749C8.24469 7.44749 7.63253 6.80268 7.63253 5.81398V2.47175H7.04347V5.81398C7.04347 7.11434 7.90974 7.96333 9.28422 7.96333C10.1736 7.96333 10.9128 7.61943 11.3517 6.82418V7.84512H11.9292V2.47175H11.3517Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M14.0019 1.17139C14.256 1.17139 14.4639 0.977952 14.4639 0.741525C14.4639 0.515843 14.256 0.322402 14.0019 0.322402C13.7478 0.322402 13.5399 0.515843 13.5399 0.741525C13.5399 0.977952 13.7478 1.17139 14.0019 1.17139ZM13.7132 7.84512H14.2907V2.47175H13.7132V7.84512Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path d="M16.0706 7.84512H16.6481V0H16.0706V7.84512Z" fill={light ? '#fff' : '#000000'} />
      <path
        d="M23.5217 0.322402V3.71837C23.0481 2.89087 22.1587 2.35353 21.0384 2.35353C19.3867 2.35353 18.0469 3.56792 18.0469 5.15843C18.0469 6.74895 19.3867 7.96333 21.0384 7.96333C22.1587 7.96333 23.0481 7.42599 23.5217 6.5985V7.84512H24.0992V0.322402H23.5217ZM21.073 7.44749C19.6985 7.44749 18.6244 6.43729 18.6244 5.15843C18.6244 3.87957 19.6985 2.86938 21.073 2.86938C22.4475 2.86938 23.5217 3.87957 23.5217 5.15843C23.5217 6.43729 22.4475 7.44749 21.073 7.44749Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M33.2993 0.322402H32.5254L29.6379 4.77155L26.7503 0.322402H25.988V7.84512H26.6002V1.16065L29.5917 5.78174H29.6956L32.6871 1.16065V7.84512H33.2993V0.322402Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M39.4168 2.47175L37.407 7.25405L35.0739 2.47175H34.4502L37.1067 7.94184L36.9797 8.232C36.6216 9.01651 36.0325 9.55385 35.2587 9.48937V9.99446C36.252 10.0697 37.1067 9.37115 37.5456 8.33947L40.0405 2.47175H39.4168Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M44.7387 7.99557C46.2171 7.99557 47.5108 7.31853 48.2038 6.2546L46.6098 5.39486C46.2633 5.97518 45.5588 6.31908 44.7387 6.31908C43.3065 6.31908 42.3825 5.4271 42.3825 4.08376C42.3825 2.74042 43.3065 1.84844 44.7387 1.84844C45.5588 1.84844 46.2518 2.19233 46.6098 2.77266L48.2038 1.91292C47.4992 0.848992 46.2056 0.171947 44.7387 0.171947C42.3016 0.171947 40.5344 1.86993 40.5344 4.08376C40.5344 6.29759 42.3016 7.99557 44.7387 7.99557Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M51.0103 7.84512H53.3665L56 0.322402H53.9787L52.1884 5.85697L50.3981 0.322402H48.3768L51.0103 7.84512Z"
        fill={light ? '#fff' : '#000000'}
      />
    </BuildMyCV>
  </StyledFlex1>
);

LogoBuildMyCV.propTypes = {
  light: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.number,
};

const LogoMySmartCV = ({ light, height, width, viewBox = '0 0 56 10' }) => (
  <StyledFlex1>
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.35194 0.153085H5.70375L3.74652 3.55377L1.7893 0.153085H0.141113V7.80736H1.7893V3.35695L3.65381 6.60455H3.83924L5.70375 3.35695V7.80736H7.35194V0.153085Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M11.7847 2.34002L10.8163 5.68603L9.67292 2.34002H7.97322L10.0232 7.55586C9.79653 8.22288 9.45659 8.46344 8.73551 8.46344V9.99429C10.1777 10.0708 11.0945 9.38195 11.6713 7.64334L13.4328 2.34002H11.7847Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M16.3763 7.96045C17.9421 7.96045 19.0546 7.08567 19.0546 5.60949C19.0546 3.99116 17.8288 3.58657 16.7369 3.23666C15.614 2.87582 15.4389 2.63526 15.4389 2.28535C15.4389 1.97918 15.6965 1.70581 16.2115 1.70581C16.8708 1.70581 17.2107 2.04478 17.458 2.59152L18.8486 1.72768C18.3232 0.601407 17.3961 0 16.2115 0C14.9651 0 13.7907 0.852905 13.7907 2.32909C13.7907 3.79433 14.8415 4.34107 15.9128 4.65817C16.9944 4.97528 17.4064 5.16117 17.4064 5.63136C17.4064 5.9266 17.2107 6.25464 16.4278 6.25464C15.614 6.25464 15.1711 5.82818 14.9136 5.19397L13.492 6.06875C13.8937 7.19502 14.8621 7.96045 16.3763 7.96045Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M25.5955 2.18694C24.8641 2.18694 24.3902 2.47124 24.1018 2.90862C23.8134 2.44937 23.3601 2.18694 22.7524 2.18694C22.0622 2.18694 21.6089 2.47124 21.372 2.84302V2.34002H19.8268V7.80736H21.372V4.72378C21.372 4.07864 21.6604 3.69592 22.1755 3.69592C22.6699 3.69592 22.9172 4.04583 22.9172 4.59257V7.80736H24.4623V4.72378C24.4623 4.07864 24.7508 3.69592 25.2658 3.69592C25.7603 3.69592 26.0075 4.04583 26.0075 4.59257V7.80736H27.5527V4.45041C27.5527 3.08358 26.7801 2.18694 25.5955 2.18694Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M32.3483 2.34002V2.85395C32.0084 2.43843 31.5036 2.18694 30.8134 2.18694C29.464 2.18694 28.3514 3.44442 28.3514 5.07369C28.3514 6.70296 29.464 7.96045 30.8134 7.96045C31.5036 7.96045 32.0084 7.70895 32.3483 7.29343V7.80736H33.8935V2.34002H32.3483ZM31.1225 6.40772C30.4117 6.40772 29.8966 5.89379 29.8966 5.07369C29.8966 4.25359 30.4117 3.73966 31.1225 3.73966C31.8332 3.73966 32.3483 4.25359 32.3483 5.07369C32.3483 5.89379 31.8332 6.40772 31.1225 6.40772Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M36.5723 3.31321V2.34002H35.0271V7.80736H36.5723V5.33612C36.5723 4.25359 37.4788 3.98022 38.1174 4.08957V2.23067C37.4685 2.23067 36.7783 2.58058 36.5723 3.31321Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M42.0089 3.91461V2.34002H40.9478V0.809166L39.4027 1.30123V2.34002H38.5786V3.91461H39.4027V5.85005C39.4027 7.38091 39.9898 8.02605 42.0089 7.80736V6.32024C41.329 6.36398 40.9478 6.32024 40.9478 5.85005V3.91461H42.0089Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M46.6516 7.92764C48.001 7.92764 49.1753 7.18408 49.7625 6.05781L49.2784 5.76257C48.8045 6.72483 47.795 7.36997 46.6516 7.36997C44.7561 7.36997 43.4479 5.86099 43.4479 3.98022C43.4479 2.09946 44.7561 0.590473 46.6516 0.590473C47.7847 0.590473 48.7839 1.22468 49.2578 2.16507L49.7419 1.86983C49.1444 0.754493 47.9804 0.0328043 46.6516 0.0328043C44.4574 0.0328043 42.9019 1.79329 42.9019 3.98022C42.9019 6.16716 44.4574 7.92764 46.6516 7.92764Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M52.8756 7.80736H53.4525L56.1411 0.153085H55.5539L53.1641 7.05287L50.7845 0.153085H50.187L52.8756 7.80736Z"
        fill={light ? '#fff' : '#000000'}
      />
    </svg>
  </StyledFlex1>
);

LogoMySmartCV.propTypes = {
  light: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.number,
};

const LogoCurriculumListo = ({ light, height, width, viewBox = '0 0 85 10' }) => (
  <StyledFlex1>
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.99733 9.2037C6.54723 9.2037 7.91691 8.38112 8.60175 7.14725L8.20526 6.92951C7.61654 8.04241 6.39104 8.78031 4.99733 8.78031C2.70252 8.78031 1.08053 7.01418 1.08053 4.83676C1.08053 2.65934 2.70252 0.893216 4.99733 0.893216C6.35499 0.893216 7.56848 1.60693 8.18123 2.69564L8.5657 2.4658C7.86885 1.26822 6.51119 0.469829 4.99733 0.469829C2.46222 0.469829 0.635986 2.42951 0.635986 4.83676C0.635986 7.24402 2.46222 9.2037 4.99733 9.2037Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M14.5107 3.02225V6.23999C14.5107 7.87305 13.5496 8.79241 12.276 8.79241C11.0625 8.79241 10.3536 7.96983 10.3536 6.82064V3.02225H9.93313V6.82064C9.93313 8.26015 10.8462 9.2037 12.24 9.2037C13.2252 9.2037 14.0782 8.73193 14.5107 7.72789V9.07064H14.9433V3.02225H14.5107Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M17.3743 4.38918V3.02225H16.9417V9.07064H17.3743V5.70773C17.3743 4.11096 18.3835 3.34886 19.4889 3.34886V2.93757C18.6358 2.93757 17.7467 3.33676 17.3743 4.38918Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M21.2345 4.38918V3.02225H20.8019V9.07064H21.2345V5.70773C21.2345 4.11096 22.2437 3.34886 23.3491 3.34886V2.93757C22.496 2.93757 21.6069 3.33676 21.2345 4.38918Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M24.8784 1.37709C25.0947 1.37709 25.2509 1.19564 25.2509 1.00209C25.2509 0.796442 25.0947 0.61499 24.8784 0.61499C24.6621 0.61499 24.506 0.796442 24.506 1.00209C24.506 1.19564 24.6621 1.37709 24.8784 1.37709ZM24.6621 9.07064H25.0947V3.02225H24.6621V9.07064Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M29.7942 9.2037C30.9717 9.2037 31.9809 8.61096 32.4375 7.6916L32.089 7.48596C31.6805 8.27225 30.8275 8.79241 29.7942 8.79241C28.2443 8.79241 27.0789 7.59483 27.0789 6.04644C27.0789 4.49805 28.2443 3.30047 29.7942 3.30047C30.8395 3.30047 31.6925 3.82064 32.077 4.60693L32.4254 4.40128C31.9809 3.49402 30.9837 2.88918 29.7942 2.88918C28.004 2.88918 26.6584 4.26822 26.6584 6.04644C26.6584 7.82467 28.004 9.2037 29.7942 9.2037Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M38.3525 3.02225V6.23999C38.3525 7.87305 37.3913 8.79241 36.1177 8.79241C34.9042 8.79241 34.1954 7.96983 34.1954 6.82064V3.02225H33.7748V6.82064C33.7748 8.26015 34.688 9.2037 36.0817 9.2037C37.0669 9.2037 37.9199 8.73193 38.3525 7.72789V9.07064H38.785V3.02225H38.3525Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path d="M40.7835 9.07064H41.216V0.23999H40.7835V9.07064Z" fill={light ? '#fff' : '#000000'} />
      <path
        d="M47.6216 3.02225V6.23999C47.6216 7.87305 46.6604 8.79241 45.3869 8.79241C44.1734 8.79241 43.4645 7.96983 43.4645 6.82064V3.02225H43.044V6.82064C43.044 8.26015 43.9571 9.2037 45.3508 9.2037C46.336 9.2037 47.1891 8.73193 47.6216 7.72789V9.07064H48.0542V3.02225H47.6216Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M56.4925 2.88918C55.6635 2.88918 54.8345 3.32467 54.438 4.28031C54.1617 3.36096 53.4168 2.88918 52.5036 2.88918C51.6746 2.88918 50.8937 3.26418 50.4852 4.20773V3.02225H50.0526V9.07064H50.4852V5.68354C50.4852 4.08676 51.3743 3.30047 52.4676 3.30047C53.4528 3.30047 54.1256 3.9416 54.1256 5.17547V9.07064H54.5582V5.68354C54.5582 4.08676 55.3992 3.30047 56.4925 3.30047C57.5018 3.30047 58.1986 3.9416 58.1986 5.17547V9.07064H58.6311V5.17547C58.6311 3.66338 57.718 2.88918 56.4925 2.88918Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path d="M61.9017 7.47386V0.602893H60.2437V9.07064H65.1096V7.47386H61.9017Z" fill="black" />
      <path
        d="M66.7484 2.29644C67.2771 2.29644 67.7096 1.86096 67.7096 1.3408C67.7096 0.820635 67.2771 0.373054 66.7484 0.373054C66.2318 0.373054 65.7992 0.820635 65.7992 1.3408C65.7992 1.86096 66.2318 2.29644 66.7484 2.29644ZM65.9795 9.07064H67.5294V3.02225H65.9795V9.07064Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M70.3308 4.73999C70.3308 4.41338 70.6431 4.24402 71.0276 4.24402C71.4722 4.24402 71.8086 4.47386 71.9888 4.86096L73.3104 4.13515C72.8418 3.30047 72.0008 2.85289 71.0276 2.85289C69.7901 2.85289 68.7448 3.54241 68.7448 4.77628C68.7448 6.90531 71.8446 6.42144 71.8446 7.30451C71.8446 7.65531 71.5082 7.82467 71.0156 7.82467C70.4149 7.82467 70.0064 7.53435 69.8382 7.03838L68.4925 7.80047C68.925 8.73193 69.8141 9.23999 71.0156 9.23999C72.3012 9.23999 73.4306 8.61096 73.4306 7.30451C73.4306 5.0787 70.3308 5.63515 70.3308 4.73999Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M77.6875 4.52225V3.02225H76.3299V1.3287L74.78 1.80047V3.02225H73.7347V4.52225H74.78V7.03838C74.78 8.67144 75.5129 9.31257 77.6875 9.07064V7.65531C76.7984 7.7037 76.3299 7.6916 76.3299 7.03838V4.52225H77.6875Z"
        fill={light ? '#fff' : '#000000'}
      />
      <path
        d="M81.4521 9.23999C83.2182 9.23999 84.636 7.84886 84.636 6.04644C84.636 4.24402 83.2182 2.85289 81.4521 2.85289C79.6859 2.85289 78.2802 4.24402 78.2802 6.04644C78.2802 7.84886 79.6859 9.23999 81.4521 9.23999ZM81.4521 7.7158C80.539 7.7158 79.8301 7.02628 79.8301 6.04644C79.8301 5.0666 80.539 4.37709 81.4521 4.37709C82.3772 4.37709 83.0861 5.0666 83.0861 6.04644C83.0861 7.02628 82.3772 7.7158 81.4521 7.7158Z"
        fill={light ? '#fff' : '#000000'}
      />
    </svg>
  </StyledFlex1>
);

LogoCurriculumListo.propTypes = {
  light: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.number,
};

const ResumeNationLogo = ({ light }) => {
  const { getBrandName } = useDomain();
  return (
    <StyledFlex $alignItems="center">
      <NoShrinkWrapper>
        <LogoV2 />
      </NoShrinkWrapper>
      <NoShrinkWrapper>
        <TextV2 $light={light}>{getBrandName()}</TextV2>
      </NoShrinkWrapper>
    </StyledFlex>
  );
};

ResumeNationLogo.propTypes = {
  light: PropTypes.bool,
};

const BlogLogo = ({ width, height, text, withHeader }) => {
  const { locale } = useIntl();

  return (
    <StyledFlex1 $withHeader={withHeader}>
      <StyledSVG xmlns="http://www.w3.org/2000/svg" height={height} width={width}>
        <title>resume-Example-7</title>
        <path
          d="M14.23,10.8H9.09a1,1,0,0,0,0,1.93h5a.89.89,0,0,0,1.07-1A1,1,0,0,0,14.23,10.8ZM5.77,22.26V4.7H16.05A5.6,5.6,0,0,1,18,5,4.94,4.94,0,0,1,20.87,7.8a6.36,6.36,0,0,1-.11,5.57,5.58,5.58,0,0,1-4.93,2.89l6,6ZM21.94,1.7H5.66A3.68,3.68,0,0,0,2,5.34V21.62a3.68,3.68,0,0,0,3.64,3.64H22a3.68,3.68,0,0,0,3.64-3.64V5.23A3.76,3.76,0,0,0,21.94,1.7Zm-5,9.1a1.07,1.07,0,1,0,0,2.14A1.15,1.15,0,0,0,18,11.87,1.07,1.07,0,0,0,16.91,10.8ZM9.3,9.2h7.6a1,1,0,1,0,0-1.93H9.3a1,1,0,1,0,0,1.93ZM12,14.44H9.09a1,1,0,0,0,0,1.93H12a1,1,0,1,0,0-1.93Z"
          transform="translate(-2.02 0.31)"
          style={{ fill: '#438ec0' }}
        />
        <StyledText
          transform="translate(29.24 22.42)"
          style={{
            fontSize: text.length > 18 ? 24 : 26,
            fill: '#3596d5',
            fontFamily: websiteFontLoad(locale).websiteBold,
          }}
        >
          <tspan style={{ letterSpacing: '-0.024988642676364612em' }}>{text}</tspan>
        </StyledText>
      </StyledSVG>
    </StyledFlex1>
  );
};

BlogLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  withHeader: PropTypes.any,
  text: PropTypes.string,
};

const Resumizeme = ({ light }) => {
  return (
    <StyledFlex1 alignItems="center">
      <ResumizemeLogo />
      <ResumizemeText light={light}>ResumizeMe</ResumizemeText>
    </StyledFlex1>
  );
};

Resumizeme.propTypes = {
  light: PropTypes.bool,
};

const TheResumeRanger = ({ light }) => {
  return (
    <StyledFlex1 alignItems="center">
      <TheResumeRangerLogo light={light} />
    </StyledFlex1>
  );
};

TheResumeRanger.propTypes = {
  light: PropTypes.bool,
};

const StyledFlex = styled(Flex)`
  max-height: 70px;
  @media (max-width: 1600px) {
    margin-right: 60px;
    margin-left: 0;
  }
  ${(p) => p.theme.max('lg')`
    margin: 0;
  `}
  @media (max-width: 980px) {
    justify-content: center !important;
    margin: 0;
  }
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      @media (max-width: 1600px) {
        margin-right: 0;
        margin-left: 60px;
      }
    `}

  ${({ $nomargin, theme: { isRTL } }) => css`
    ${isRTL &&
    $nomargin &&
    css`
      margin-left: 0 !important;
    `}
  `}
`;
const StyledFlex1 = styled(Flex)`
  @media (max-width: 1600px) {
    margin-right: 60px;
    margin-left: 0;
  }
  ${({ $withHeader }) =>
    $withHeader &&
    css`
      margin: 0 !important;
    `}
  ${(p) => p.theme.max('lg')`
    margin: 0;
  `}
  @media (max-width: 979px) {
    justify-content: center !important;
    margin: 0;
  }
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      @media (max-width: 1600px) {
        margin-right: -10px !important;
      }
    `}
`;
const NoShrinkWrapper = styled(Flex)`
  flex-shrink: 0;
`;
const TextV2 = styled(Flex)`
  font-family: ${({ theme }) => theme.font.family.websiteBold};
  font-size: 20px;
  font-weight: bold;
  line-height: 1.09;
  letter-spacing: -0.44px;
  color: var(--text);
  margin-left: 12px;
  text-transform: capitalize;
  @media (max-width: 768px) {
    display: none;
  }
  ${({ $light }) =>
    $light &&
    css`
      color: var(--light-values-white);
    `}
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      margin-right: 12px;
    `}
    ${({ theme }) => theme.max('md')`
      display: none;
    `}
`;
const StyledSVG = styled.svg`
  ${({ theme }) =>
    theme.isRTL &&
    css`
      text {
        direction: ltr;
      }
    `}
`;

const StyledText = styled.text`
  ${({ theme }) => theme.max('sm')`
     display:none;
  `}
`;

const SVG = styled.svg`
  fill: #000;
  ${(p) =>
    p.light &&
    css`
      fill: white;
    `}

  ${({ theme }) => theme.max('sm')`
     width: 115px;
  `}
`;

const BuildMyCV = styled.svg`
  margin-top: 15px;
`;

const LinkUnstyled = styled.div`
  text-decoration: none;
  ${({ $locale, $isMobile }) =>
    $isMobile &&
    ($locale === 'ar' || $locale === 'he') &&
    css`
      position: relative;
    `}

  ${({ theme }) =>
    theme.isRTL &&
    css`
      direction: ltr;
    `}
`;
const ResumizemeText = styled.div`
  padding: 0;
  font-family: ${({ theme }) => theme.font.family.websiteBold};
  font-size: 20px;
  line-height: 1.09;
  letter-spacing: -0.44px;
  color: var(--text);
  margin-left: 12px;
  text-transform: capitalize;
  ${({ light }) =>
    light &&
    css`
      color: var(--light-values-white);
    `}
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      margin-left: 0;
      margin-right: 12px;
    `}
  @media (max-width: 768px) {
    display: none;
  }
`;
export default withRouter(Logo);
